export enum LoginTypes {
  EMAIL = 'email',
  PHONE = 'phone',
}

export type TLoginState = {
  type: LoginTypes | false;
  value: string;
};
